<template>
	<div>
		<el-amap class="amap-box" :vid="'amap-vue'" :map-style="mapStyle" :map-manager="amapManager" :zoom="zoom" :center="center">
			<el-amap-marker v-for="(marker,index) in markers" :key="index" :events="marker.events" :position="marker.position" />
			<el-amap-info-window
				v-if="window"
				:position="window.position"
				:visible="window.visible"
				:content="window.content"
				:offset="window.offset"
				:close-when-click-map="true"
				:is-custom="true"
			>
				<div id="info-window">
					<p class="title">项目名称: {{ window.name }}</p>
					<p class="address">项目地址: {{ window.address }}</p>
				</div>
			</el-amap-info-window>
		</el-amap>
	</div>
</template>

<script>
import { AMapManager, lazyAMapApiLoaderInstance } from 'vue-amap';
let amapManager = new AMapManager();
export default {
	props: {
		MapData:{
			type:Object
		}
	},
	data() {
		let self = this;
		return {
			amapManager,
			projectLocation: [{
				position: '106.539122,29.377762',
				address: '鱼胡路',
				name: '项目测试111'
			},
			{
				position: '106.545935,29.392486',
				address: '汉海海洋公园',
				name: '项目测试'
			}],
			zoom: 12,
			center: [106.54451,29.402152],// 设置的中心点位置
			mapStyle: 'amap://styles/darkblue',
			expandZoomRange: true,
			markers: [],
			windows: [],
			window: '',
			lng: 0,
			lat: 0,
			events: {
				click(e) {
					const { lng, lat } = e.lnglat
					self.lng = lng
					self.lat = lat
				},
			},
		};
	},
	mounted() {
		this.fnInit()
	},
	watch: {
		MapData: {
			handler: function(newV, oldV) {
				this.fnInit()
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		fnInit(){
			this.projectLocation = this.MapData.projectData
			this.center = this.MapData.center
			this.$nextTick(()=>{
				this.point()
			})
		},
		point() {
			const markers = []
			const windows = []
			const that = this
			this.projectLocation.forEach((item, index) => {
				markers.push({
					position: item.position.split(','),
					events: {
						mouseover() {
							// 方法：鼠标移动到点标记上，显示相应窗体
							that.windows.forEach(window => {
								window.visible = false // 关闭窗体
							})
							that.window = that.windows[index]
							that.$nextTick(() => {
								that.window.visible = true
							})
						}
					}
				})
				windows.push({
					position: item.position.split(','),
					isCustom: true,
					offset: [170, 0], // 窗体偏移
					showShadow: false,
					visible: false, // 初始是否显示
					address: item.address,
					name: item.name
				})
			})
			//  加点
			this.markers = markers
			// 加弹窗
			this.windows = windows
		},
	}
};
</script>

<style scoped lang="scss">
.amap-box {
	width: 590px;
	height: 590px;
}
.amap-page-container {
		position: relative;
	}
	#info-window{
		width: 300px;
		height: 100px;
		margin-left: 30px;
		padding: 5px;
		background: #091120;
		color: #FFFFFF;
		border: 1px solid #3a74dd;
		border-radius: 4px;
		position: relative;
		overflow: hidden;
		// .detail{
		// 	width: 100%;
		// 	height: 24px;
		// 	color: #fff;
		// 	background-color: #1a73e8;
		// 	position: absolute;
		// 	bottom: 0;
		// 	font-size: 12px;
		// 	line-height: 24px;
		// 	text-align: center;
		// 	cursor: pointer;
		// }
	}
</style>



// WEBPACK FOOTER //
// src/components/Map/map.vue